import React, { useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useClickOutside } from 'hooks';
import { useAccountPreferences } from 'modules/scheduler/hooks';
import { getViewObject } from 'modules/scheduler/utils/schedulerUtil';
import { findByValue, scales } from '../../../../enums/scale';
import { useSelector } from 'react-redux';
import { getCompanySettings } from '../../../../../../selectors/company';
import { PersonalPreferencesSidebar } from '@hub-mono/app-modules';
import styled from 'styled-components';
import { SCHEDULER_FOOTER_FIXED_HEIGHT } from 'constants';

const Customization = props => {
    const { onClose, isOpen, schedulerRef } = props;
    const params = useParams();
    const viewObject = getViewObject(params);
    const {
        gridPreferences,
        updateGridPreferences,
        updateSubGroupsPositionSetting,
        subGroupsPositionSetting,
    } = useAccountPreferences(schedulerRef, viewObject);
    const companySettings = useSelector(getCompanySettings);
    const node = useRef();

    const handleClickOutside = useCallback(
        event => {
            if (node.current && !node.current.contains(event.target) && isOpen) {
                onClose();
            }
        },
        [onClose, isOpen]
    );

    const updateGridPreferencesWrapper = newPreferences => {
        if (newPreferences.hasOwnProperty('eventSmartResize')) {
            const currentScale = gridPreferences.defaultScale || 'Day';
            const scale = findByValue(currentScale);
            const eventMoveSkipNonBusiness = [scales.WEEK.value, scales.MONTH.value].includes(scale?.value)
                ? false
                : newPreferences.eventSmartResize || companySettings.grid.hideNonWorkingDays;

            schedulerRef.current.control.update({
                eventMoveSkipNonBusiness,
            });
        } else if (newPreferences.hasOwnProperty('defaultScale')) {
            const scale = findByValue(newPreferences.defaultScale);
            const eventMoveSkipNonBusiness = [scales.WEEK.value, scales.MONTH.value].includes(scale?.value)
                ? false
                : gridPreferences.eventSmartResize || companySettings.grid.hideNonWorkingDays;

            schedulerRef.current.control.update({
                eventMoveSkipNonBusiness,
            });
        }
        updateGridPreferences(newPreferences);
    };

    useClickOutside(handleClickOutside);

    return (
        <Wrapper
            ref={node}
            className={classNames({ 'fade-in': isOpen, 'footer-visible': gridPreferences.schedulerFooterVisible })}
        >
            <PersonalPreferencesSidebar
                onClose={onClose}
                gridPreferences={gridPreferences}
                onGridPreferencesChange={updateGridPreferencesWrapper}
                subGroupsPosition={subGroupsPositionSetting}
                onSubGroupsPositionChange={updateSubGroupsPositionSetting}
            />
        </Wrapper>
    );
};

Customization.propTypes = {
    schedulerRef: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
};

export default Customization;

const Wrapper = styled.div`
    width: 392px;
    right: -392px;
    top: 62px;
    bottom: 0;
    position: fixed;
    z-index: 99999;
    background-color: transparent;
    transition: 0.5s;
    visibility: hidden;

    &.footer-visible {
        bottom: ${SCHEDULER_FOOTER_FIXED_HEIGHT + 10}px;
    }

    &.fade-in {
        right: 10px;
        visibility: visible;
    }
`;
